const cfg = {
  title: 'RIMAG RIS•CLOUD v1.9',
  VUE_APP_BASE_VERSION: '1.9.38',
  VUE_APP_BASE_HOST: '',
  VUE_APP_BASE_API: ''
}
export default cfg
